import Enum from "../../../../../../enums/Enum";

const SmokingUseEnum = new Enum({
    NA: {name: "N/A"},
    NONDRINKER: {name: "Non-Smoker"}
});

export default SmokingUseEnum;